// extracted by mini-css-extract-plugin
export var tosLink = "_bo-0";